import ProgressChart from './ProgressChart';

export default ProgressChart;
